import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

// Placeholder images for collections
const collections = [
  {
    id: 1,
    title: "Antique Bridal Jewellery",
    image: "https://images.unsplash.com/photo-1543294001-f7cd5d7fb516?auto=format&fit=crop&q=80&w=800",
    link: "/shop/antique"
  },
  {
    id: 2,
    title: "Diamond Necklaces",
    image: "https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?auto=format&fit=crop&q=80&w=800",
    link: "/shop/diamond"
  },
  {
    id: 3,
    title: "Gold Necklaces",
    image: "https://images.unsplash.com/photo-1611591437281-460bfbe1220a?auto=format&fit=crop&q=80&w=800",
    link: "/shop/gold"
  }
];

const FeaturedCollections = () => {
  return (
    <div className="w-full bg-white py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-serif text-[#D4AF37] mb-3">
            Featured Collections
          </h2>
          <p className="text-gray-500 text-sm md:text-base tracking-widest uppercase">
            Must Loved Products from Categories
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {collections.map((item) => (
            <Link 
              key={item.id} 
              to={item.link}
              className="group block relative overflow-hidden aspect-[4/5] bg-gray-100"
            >
              <img 
                src={item.image} 
                alt={item.title} 
                className="object-cover w-full h-full transition-transform duration-700 group-hover:scale-105"
              />
              
              {/* Gradient overlay for text readability */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-80"></div>
              
              <div className="absolute bottom-0 left-0 w-full p-6 flex justify-between items-end">
                <div>
                  <p className="text-[#D4AF37] text-xs font-semibold tracking-wider uppercase mb-1">
                    Explore
                  </p>
                  <h3 className="text-white font-serif text-xl md:text-2xl w-[80%]">
                    {item.title}
                  </h3>
                </div>
                
                <div className="bg-[#D4AF37] p-2 rounded-full cursor-pointer transition-colors hover:bg-white text-black mb-1">
                  <ArrowUpRight size={20} />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FeaturedCollections;
